import { useEffect, useState } from 'react';
import { useBooleanState } from 'react-use-object-state';
import { useDebouncedCallback } from 'use-debounce';
import useInitialValue from './useInitialValue';

export interface ValidationReturnValue {
  dirty: boolean;
  helpText: string;
  error: boolean;
}
const useValidation = (
  fieldValue: any,
  validationFunction: (value: any) => { error: boolean; helpText: string }
): ValidationReturnValue => {
  const [helpText, setHelpText] = useState<string>('');
  const error = useBooleanState(true);
  const dirty = useBooleanState(false);
  const initialValue = useInitialValue(fieldValue);

  const [debouncedValidate] = useDebouncedCallback(() => {
    if (!dirty.state && fieldValue !== initialValue) {
      dirty.setTrue();
    }
    const result = validationFunction(fieldValue);
    error.setState(result.error);
    setHelpText(result.helpText);
  }, 500);

  useEffect(debouncedValidate, [fieldValue, dirty.state, initialValue]);

  return { dirty: dirty.state, helpText, error: error.state };
};

export default useValidation;
